module.exports = __webpack_public_path__ + "img/1490383792.f6606803.jpg";